import { useEffect } from 'react';
import { AppRouter } from './router/AppRouter';
import { useAuthStore } from '../features/auth/store/authStore';
import { useUIStore } from '../shared/store/uiStore';
import { StripeProvider } from '../shared/providers/StripeProvider';
import { Toaster } from 'sonner';

export function App() {
  const { initialize } = useAuthStore();
  const { initializeTheme, isDarkMode } = useUIStore();

  useEffect(() => {
    initialize();
  }, [initialize]);

  // Returns an unsubscribe for the OS colour-scheme listener, so the effect
  // hands it straight back to React as its cleanup.
  useEffect(() => initializeTheme(), [initializeTheme]);

  return (
    <div data-testid="app">
      <StripeProvider>
        <AppRouter />
        <Toaster
          position="top-right"
          expand={false}
          richColors
          closeButton={false}
          theme={isDarkMode ? 'dark' : 'light'}
        />
      </StripeProvider>
    </div>
  );
}
